import ProcessFlowStep from "~/models/processFlows/processFlowStep"
import {ProcessFlowStepType} from "../../../enums/processFlowStepType"
import {IDisplayAFormStep, IProcessFlowVariable} from '~/interfaces/processFlowInterfaces'
import ProcessFlow from '~/models/processFlows/processFlow'
import IterationStep from '~/models/processFlows/steps/iterationStep'

export class ProcessFlowDisplayAFormStep extends ProcessFlowStep implements IDisplayAFormStep {
  step_type: ProcessFlowStepType.DisplayAForm
  heading: string
  description: string
  variable_client_id: string

  constructor(parent: ProcessFlow | IterationStep, options?) {
    super(parent, options)
    this.defineProperty<this>('heading', null)
    this.defineProperty<this>('description', null)
    this.defineProperty<this>('variable_client_id', null)
  }

  // ******************** RELATIONS AND REPOS ******************** //
  // ******************** RELATIONS AND REPOS END ******************** //

  get defaultTitle(): string {
    if (this.variable_client_id) {
      return `Display a form for ${this.variable.name}`
    } else {
      return `Display a form`
    }
  }

  get variable(): IProcessFlowVariable {
    if (this.variable_client_id) {
      return this.processFlow.variablesHandler.find(this.variable_client_id)
    }
  }
}